"use client";
import { useEffect } from "react";
import useSettings from "../lib/features/settings/settings.hook";
import { Settings } from "../lib/features/settings/settings.types";
import { setSettings } from "../lib/features/settings/settings.slice";
import { store } from "../lib/store";

interface SettingsInitializerProviderProps {
  initialSettings?: Settings;
}

const SettingsInitializerProvider = ({ initialSettings }: SettingsInitializerProviderProps) => {
  const { fetchSettings } = useSettings();

  // initialSettings varsa store'a senkron yaz (render öncesi, hook dışı)
  if (initialSettings && !store.getState().settings.data) {
    store.dispatch(setSettings(initialSettings));
  }

  useEffect(() => {
    if (!initialSettings) {
      fetchSettings();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SettingsInitializerProvider;
